import React, { useState } from "react";
import { Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { Formik } from "formik";
import * as yup from "yup";
import { addService } from "app/services/serviceMasterService";
import {
  RenderTextInput,
  RenderSelectInput,
  RenderTextArea,
} from "app/common/renderInput";

const validationModel = yup.object().shape({
  serviceType: yup.string().required("Service Name is required!"),
  serviceDescription: yup.string().required("Service Description is required!"),
  status: yup.boolean().required("Status is required!"),
});

const AddServiceAllocation = ({ loadNotification, refreshData }) => {
  const [serviceType, setServiceType] = useState("");
  const [serviceDescription, setServiceDescription] = useState("");
  const [status, setStatus] = useState(true);

  const statusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];

  const resetForm = (setFieldValue) => {
    setServiceType("");
    setServiceDescription("");
    setStatus(true);

    setFieldValue("serviceType", "");
    setFieldValue("serviceDescription", "");
    setFieldValue("status", true);
  };

  const handleSubmit = async (values) => {
    try {
      const response = await addService(values);

      if (response.status === "Success") {
        NotificationManager.success(response.message);
        document.querySelectorAll(".btn-close")[0].click();
        loadNotification();
        // resetForm(setFieldValue);
      } else {
        NotificationManager.error(response.message);
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <Formik
      initialValues={{
        serviceType,
        serviceDescription,
        status,
      }}
      validationSchema={validationModel}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
      }) => (
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="addNewNotificationLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addNewNotificationLabel">
                  Add Service Allocation
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => resetForm(setFieldValue)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <Row>
                    <RenderTextInput
                      name="serviceType"
                      display="Service Name"
                      placeholder="Service Name"
                      value={values.serviceType}
                      error={errors.serviceType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.serviceType}
                      required
                    />
                  </Row>
                  <Row className="mb-2">
                    <RenderTextArea
                      name="serviceDescription"
                      display="Service Description"
                      placeholder="Service Description"
                      value={values.serviceDescription}
                      error={errors.serviceDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.serviceDescription}
                      required
                    />
                  </Row>
                  <Row>
                    <RenderSelectInput
                      type="text"
                      display="Status"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.status}
                      touched={touched.status}
                      items={statusOptions}
                      required
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary ms-4">
                      Add Services
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default AddServiceAllocation;

// import {
//   RenderSelectInput,
//   RenderTextaera,
//   RenderTextInput,
// } from "app/common/renderInput";
// import { Formik } from "formik";
// import * as yup from "yup";
// import React, { Component } from "react";
// import { Row } from "react-bootstrap";
// import { NotificationManager } from "react-notifications";
// import serviceMasterService from "app/services/serviceMasterService";

// const validationModel = yup.object().shape({
//   serviceType: yup.string().required("Service Name is required!"),
//   serviceDescription: yup.string().required("Service Description is required!"),
//   status: yup.boolean().required("status is required!"),
// });

// export class AddServiceAllocation extends Component {
//   state = {
//     serviceType: "",
//     serviceDescription: "",
//     status: true,
//   };
//   statusOptions = [
//     { value: "true", label: "Active" },
//     { value: "false", label: "Inactive" },
//   ];

//   resetForm = (setFieldValue) => {
//     this.setState({
//       serviceType: "",
//       serviceDescription: "",
//       status: true,
//     });

//     setFieldValue("serviceType", "");
//     setFieldValue("serviceDescription", "");
//     setFieldValue("status", true);
//   };

//   handleSubmit = async (values) => {
//     try {
//       const response = await serviceMasterService.addService(values);

//       if (response.status === "Success") {
//         NotificationManager.success(response.message);
//         document.querySelectorAll(".close")[0].click();
//         this.props.loadNotification();

//         // this.resetForm();
//       } else {
//         NotificationManager.success(response.message);
//       }
//     } catch (error) {
//       throw error;
//     }
//   };

//   render() {
//     return (
//       <Formik
//         initialValues={this.state}
//         validationSchema={validationModel}
//         onSubmit={this.handleSubmit}
//         enableReinitialize={true}
//       >
//         {({
//           values,
//           errors,
//           touched,
//           handleChange,
//           handleBlur,
//           handleSubmit,
//           setFieldValue,
//         }) => {
//           return (
//             <div
//               className="modal fade"
//               id="exampleModal"
//               tabIndex="-1"
//               role="dialog"
//               aria-labelledby="addNewNotificationLabel"
//               aria-hidden="true"
//             >
//               <div className="modal-dialog modal-md" role="document">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <h5 className="modal-title" id="addNewNotificationLabel">
//                       Add Service Allocation
//                     </h5>
//                     <button
//                       type="button"
//                       className="close"
//                       data-dismiss="modal"
//                       aria-label="Close"
//                       onClick={() => this.resetForm(setFieldValue)}
//                     >
//                       <span aria-hidden="true">&times;</span>
//                     </button>
//                   </div>
//                   <div className="modal-body">
//                     <form
//                       className="needs-validation"
//                       onSubmit={handleSubmit}
//                       noValidate
//                     >
//                       <Row>
//                         <RenderTextInput
//                           name="serviceType"
//                           display="Service Name"
//                           placeholder="Service Name"
//                           value={values.serviceType}
//                           error={errors.serviceType}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.serviceType}
//                           required
//                         ></RenderTextInput>
//                       </Row>
//                       <Row className="mb-2">
//                         <RenderTextaera
//                           name="serviceDescription"
//                           display="Service Description"
//                           placeholder="Service Description"
//                           value={values.serviceDescription}
//                           error={errors.serviceDescription}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.serviceDescription}
//                           required
//                         ></RenderTextaera>
//                       </Row>

//                       <Row>
//                         <RenderSelectInput
//                           type="text"
//                           display="Status"
//                           name="status"
//                           value={values.status}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           error={errors.status}
//                           touched={touched.status}
//                           items={this.statusOptions}
//                           required
//                         ></RenderSelectInput>
//                       </Row>

//                       <Row className="d-flex align-items-center justify-content-center mt-3">
//                         <button type="submit" className="btn btn-primary ml-4">
//                           Add Services
//                         </button>
//                       </Row>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         }}
//       </Formik>
//     );
//   }
// }

// export default AddServiceAllocation;
